<template>
    <div class="preaching">
        <h2>校园招生宣讲会行程</h2>
        <h3>（具体宣讲时间和地点请关注企业官网和各相关高校网站）</h3>
        <div class="table">
            <el-table
                    border
                    :data="tableData"
                    header-row-class-name="elHeader"
                    cell-class-name="elCell"
                    :highlight-current-row="false"
                    :span-method="objectSpanMethod"
                    style="width: 100%; margin-top: 20px">
                <el-table-column
                        prop="time"
                        label="时 间"
                        align="center"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="address"
                        align="center"
                        width="170"
                        label="地 点">
                </el-table-column>
                <el-table-column
                        prop="school"
                        align="center"
                        width="508"
                        label="宣 讲 院 校">
                </el-table-column>
            </el-table>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Footer from '../base/Footer';
    import MarqueeTips from 'vue-marquee-tips';
    import { merge, spanMethod} from './mergeClass'
    export default {
        name: 'Preaching',
        props: {},
        components: {Footer,MarqueeTips},
        data() {
            return {
                tableData: [
                    {
                        time: '9月上旬',
                        address: '上海',
                        school: '同济大学'
                    },
                    {
                        time: '9月上旬',
                        address: '兰州',
                        school: '兰州大学'
                    },
                    {
                        time: '9月上旬',
                        address: '西安',
                        school: '长安大学'
                    },
                    {
                        time: '9月上旬',
                        address: '北京',
                        school: '中国地质大学（北京）、中国矿业大学'
                    },
                    {
                        time: '9月上旬',
                        address: '北京',
                        school: '北京工业大学'
                    },
                    {
                        time: '9月下旬',
                        address: '武汉',
                        school: '中国地质大学（武汉）、武汉大学'
                    },
                    {
                        time: '9月下旬',
                        address: '青岛',
                        school: '山东科技大学、中国海洋大学'
                    },
                    {
                        time: '9月下旬',
                        address: '石家庄',
                        school: '河北地质大学、石家庄铁道大学'
                    },
                    {
                        time: '9月下旬',
                        address: '南京',
                        school: '河海大学、南京工业大学'
                    },
                    {
                        time: '9月下旬',
                        address: '成都',
                        school: '成都理工大学、西南交通大学'
                    },
                    {
                        time: '10月上旬',
                        address: '南昌',
                        school: '东华理工大学、江西理工大学'
                    },
                    {
                        time: '10月上旬',
                        address: '长沙',
                        school: '中南大学'
                    },
                    {
                        time: '10月上旬',
                        address: '长春',
                        school: '吉林大学'
                    }
                ],
                merge: {}
            }
        },
        created() {
            this.processing()
        },
        methods: {
            processing(){
                //可以进行级联合并，当第二个字段受第一个字段限制时候，放入其children中
                let countField = [
                    {
                        field: 'time',
                    },
                ];

                this.merge = {};
                let das = this.merge;

                let merges = new merge(countField, das, this.tableData);
                merges.startCalculation();

                /**
                 * 如果涉及到三层级联，则需要在半秒后进行数据整合，为第三级以后setTimeout提供计算时间
                 */
                setTimeout(() => {
                    this.tableData = this.tableData;
                },500);
            },
            // /**
            //  * 官方提供的合并触发方法
            //  */
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    return spanMethod(this.merge['time'] || [], rowIndex);
                }

            },
        },


    }
</script>

<style scoped lang="less">
    .preaching {
        width: 100%;
        background: #FFF;
        margin-top: 100px;
        text-align: center;
        h2 {
            margin: 20px 0 20px;
            /*font-size: 26px;*/
            /*!*font-weight: 550;*!*/
            /*letter-spacing:8px;*/
            /*color: #3d3d37;*/
            color: #102b6a;

            font-size: 26px;
            /*margin: 30px 0;*/
            letter-spacing: 8px;
            font-weight: 700;
        }
        h3{
            margin-bottom: 20px;
        }

        .table {
            width: 800px;
            margin: 40px auto 120px;
            background-color: #fff;
            .el-table{
                margin-top: 0!important;
            }
            /*.el-table {*/
            /*    padding: 20px;*/
            /*    a {*/
            /*        color: #606266;*/
            /*        text-decoration: none;*/
            /*    }*/
            /*}*/
            .item {
                margin-top: 10px;
            }
        }

        .schedule {
            width: 1000px;
            margin-bottom: 50px;
        }

    }
</style>
<style lang="less">
    .el-carousel__arrow {
        height: 80px !important;
        width: 70px !important;
        border-radius: 5px !important;
        font-size: 28px !important;
    }
    .elHeader{
        color: #333333;
        font-size: 16px;
        font-weight: 800;
        background-color: #cccccc!important;
    }
    .elCell{
        padding: 7px 0!important;
        font-size: 16px;
    }


    .el-table--border, .el-table--grou{
        border-color: rgb(217, 236, 255) !important;
        border-width: 2px!important;
    }
    .el-table--border::after, .el-table--group::after{
        background-color: rgb(217, 236, 255)!important;
        border-width: 2px!important;
    }
    .el-table--border::after, .el-table--group::after, .el-table::before{
        background-color: rgb(217, 236, 255)!important;
        border-width: 2px!important;
    }
    .el-table{

        td,th,tr{
            border-color: rgb(217, 236, 255)!important;
            border-width: 2px!important;
            color: #000000!important;
        }
    }
</style>